/* eslint-disable @typescript-eslint/no-explicit-any */
import RoomIcon from '@mui/icons-material/Room'
import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import React from 'react'
import Typography from 'src/components/Typography'
import { NEAR_USER } from '../../constants'
import { Colors, FontWeight } from '../../constants/theme'
import { IInternalSearchProps } from './types'
import useAutocomplete from './useAutocomplete'

const CustomPaper = (props: any) => {
  return (
    <Paper
      {...props}
      elevation={9}
      sx={{
        borderRadius: 5,
        marginTop: 0.5,
        color: `${Colors.primary}`,
        lineHeight: 10,
        height: '100%',
        backgroundColor: Colors.grey300,
        boxShadow:
          'box-shadow: 0px 12px 34px -12px rgba(23, 94, 133, 0.30); !important'
      }}
    />
  )
}

const Wrapper: React.FC<IInternalSearchProps> = ({
  handleOnSelect,
  hideCloseByOption,
  label = 'Ingrese una dirección',
  placeholder,
  size = 'small',
  hideAddornment,
  isNotAtDetailsPage,
  sx,
  Input,
  dontClearSearch,
  error,
  ...props
}) => {
  const {
    searchValue,
    checked,
    options,
    loading,
    handleOnChangeAutocomplete,
    handleOnChange,
    handleKeyDown,
    handleOnClick,
    clearSearch
  } = useAutocomplete({
    handleOnSelect,
    hideCloseByOption,
    dontClearSearch
  })

  return (
    <Autocomplete
      freeSolo
      selectOnFocus
      id="custom-autocomplete"
      options={options}
      loading={loading}
      loadingText="Cargando..."
      noOptionsText="No se encontraron resultados"
      value={searchValue}
      onChange={handleOnChangeAutocomplete}
      slots={{ paper: CustomPaper }}
      getOptionLabel={(opt) =>
        typeof opt === 'string' ? opt : (opt.description ?? searchValue)
      }
      sx={sx}
      filterOptions={(x) => x}
      isOptionEqualToValue={(option, value) =>
        typeof option !== 'string' &&
        typeof value !== 'string' &&
        option.description === value.description &&
        option.description === searchValue
      }
      renderInput={(params) => (
        <Input
          params={params}
          searchValue={searchValue}
          label={label}
          size={size}
          hideAddornment={hideAddornment}
          isNotAtDetailsPage={isNotAtDetailsPage}
          loading={loading}
          handleOnChange={handleOnChange}
          handleKeyDown={handleKeyDown}
          handleOnClick={handleOnClick}
          clearSearch={clearSearch}
          placeholder={placeholder}
          error={error}
          {...props}
        />
      )}
      renderOption={(props, { placeId, description }) => (
        <React.Fragment key={placeId}>
          <Collapse in={checked} collapsedSize={40}>
            <Box
              component="li"
              {...props}
              sx={{
                top: 0,
                '& > img': { mr: 2, flexShrink: 0, p: 1 },
                mt: 0,
                fontSize: '30px !important'
              }}
            >
              <RoomIcon
                className="mr-[10px] rounded-[4px] bg-[rgba(0,162,255,0.1)] p-[2px]"
                sx={{
                  color: Colors.blue500,
                  width: '28px',
                  height: '28px',
                  mr: 3,
                  ml: -0.5
                }}
                style={{ backgroundColor: 'transparent' }}
              />

              <Typography
                fontSize={17}
                color={
                  placeId === NEAR_USER ? Colors.black500 : Colors.black400
                }
                fontWeight={FontWeight.regular}
                lineHeight="24px"
              >
                {description}
              </Typography>
            </Box>
          </Collapse>
        </React.Fragment>
      )}
    />
  )
}

export default React.memo(Wrapper)
